
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { StrictMode } from 'react'
import { HelmetProvider } from 'react-helmet-async'
import App from './App'
import { i18nInitPromise } from './i18n/index'
import './index.css'
import { AppCountProvider } from '@/contexts/AppCountContext'

// Wait for i18n to be fully initialized before rendering
i18nInitPromise.then(() => {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <HelmetProvider>
        <BrowserRouter>
          <AppCountProvider>
            <App />
          </AppCountProvider>
        </BrowserRouter>
      </HelmetProvider>
    </StrictMode>,
  )
})